import React from 'react'
import _ from 'lodash'

export default class QuantitySelector extends React.Component {
    constructor(props) {
        super(props);
        const { selectedTicket, availableTicket, order, default_tickets, minWebTicketCount } = props;
        
       
        this.state = {
            quantity: selectedTicket ? selectedTicket.quantity /*: minWebTicketCount > 0 ? minWebTicketCount*/ 
                 : availableTicket.defaultQuantity === 0 ? '0' : order.selected.tickets[0] ? order.selected.tickets[0].quantity
                    : 0,
          
           
        };

        this.increment = this.increment.bind(this);
        this.decrement = this.decrement.bind(this);
    }

    debounceMultipleClicks = _.debounce((quantity) => {
        const { ticketQuantityChanged, availableTicket, } = this.props;
         ticketQuantityChanged(availableTicket.id, quantity);
    }, 400)

   


    canIncrement(quantity) {
        const { freeSeats, availableTicket, canIncrementTotalQuantity, canIncrementTotalPoints, order,  } = this.props;
     
        const newQuantity =  quantity + 1;
        const totalTicketQuantity = order.selected.totalTicketQuantity;
      

        const canIncrement =  (freeSeats > 1 || freeSeats == 1 && quantity == 0 && totalTicketQuantity == 0) && (newQuantity <= Math.max(availableTicket.buyMax, availableTicket.reserveMax)) && canIncrementTotalQuantity();
        if (availableTicket.points ) return canIncrementTotalPoints(availableTicket.points, newQuantity) && canIncrement;
        else return canIncrement;
        
    }

    increment() {
       
        const { incrementTotalQuantity, isIncrementingPossible, maxWebTicketCount, order, totalTicketQuantity } = this.props;
        let { quantity } = this.state;
      
        //const total = order.selected.tickets.reduce((sum, item) => sum + item.quantity, 0);
    
     //   this.debounceMultipleClicks(total);

        if (this.canIncrement(quantity) ) {

            if (maxWebTicketCount > 0 ) {
                quantity < maxWebTicketCount && this.setState({ quantity: ++quantity });
                   
                   
            }
           
            else 
              
                this.setState({ quantity: ++quantity })

                this.debounceMultipleClicks(quantity);
                
            
        }
        
      
    }

  

    decrement() {
       

        const { decrementTotalQuantity, minWebTicketCount } = this.props;
        let { quantity } = this.state;
        if (quantity > 0) {
            if (minWebTicketCount > 0) {
                quantity > minWebTicketCount && this.setState({ quantity: --quantity });
            }
          else   this.setState({ quantity: --quantity });
            decrementTotalQuantity();
            this.debounceMultipleClicks(quantity);
        }
    }

    render() {
        const { availableTicket, order, site_type, canIncrementTotalQuantity, freeSeats, maxWebTicketCount, selectedTicket, default_tickets, isIncrementingPossible, isDecrementingPossible, minWebTicketCount, totalTicketQuantity } = this.props;
        let { quantity } = this.state;
     
       
        const decrementClasses = !order.isFetching && quantity > 0 && isDecrementingPossible() === false ? 'decrement' : 'decrement deactivated';
        let incrementClasses = !order.isFetching && (freeSeats > 1 || freeSeats == 1 && quantity == 0 && order.selected.totalTicketQuantity == 0)
            && canIncrementTotalQuantity() && isIncrementingPossible() ? 'increment' : 'increment deactivated';
        if (order.clubCard && availableTicket.points > order.clubCard.remainingPoints) incrementClasses = 'increment deactivated';

        return (
            <div className="QuantitySelector">
                <div className={decrementClasses} onClick={this.decrement}>
                 
                    {  !order.isFetching && quantity > 0 && isDecrementingPossible() === false ? <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
                        <circle cx="24" cy="24" r="24" fill="white" />
                        <path d="M13.8 25.2C13.3582 25.2 13 24.8418 13 24.4V22.8C13 22.3582 13.3582 22 13.8 22H34.6C35.0418 22 35.4 22.3582 35.4 22.8V24.4C35.4 24.8418 35.0418 25.2 34.6 25.2H13.8Z" fill="#333333" />
                    </svg>
                        : <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
                            <circle cx="24" cy="24" r="24" fill="grey" />
                            <path d="M13.8 25.2C13.3582 25.2 13 24.8418 13 24.4V22.8C13 22.3582 13.3582 22 13.8 22H34.6C35.0418 22 35.4 22.3582 35.4 22.8V24.4C35.4 24.8418 35.0418 25.2 34.6 25.2H13.8Z" fill="#333333" />
                    </svg>
                        
                      
                    }
                   
                </div>
                <div className="quantity">{quantity}</div>
                <div className={incrementClasses} onClick={this.increment}>
                    { !order.isFetching && (freeSeats > 1 || freeSeats == 1 && quantity == 0 && order.selected.totalTicketQuantity == 0)
                        && canIncrementTotalQuantity() && isIncrementingPossible() ?
                        <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
                            <circle cx="24" cy="24" r="24" fill="white" />
                            <path d="M35.4 23.4V25C35.4 25.4418 35.0418 25.8 34.6 25.8H25.8V34.6C25.8 35.0418 25.4418 35.4 25 35.4H23.4C22.9582 35.4 22.6 35.0418 22.6 34.6V25.8H13.8C13.3582 25.8 13 25.4418 13 25V23.4C13 22.9582 13.3582 22.6 13.8 22.6H22.6V13.8C22.6 13.3582 22.9582 13 23.4 13H25C25.4418 13 25.8 13.3582 25.8 13.8V22.6H34.6C35.0418 22.6 35.4 22.9582 35.4 23.4Z" fill="#191C28" />
                        </svg>  : 
                        <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
                            <circle cx="24" cy="24" r="24" fill="grey" />
                            <path d="M35.4 23.4V25C35.4 25.4418 35.0418 25.8 34.6 25.8H25.8V34.6C25.8 35.0418 25.4418 35.4 25 35.4H23.4C22.9582 35.4 22.6 35.0418 22.6 34.6V25.8H13.8C13.3582 25.8 13 25.4418 13 25V23.4C13 22.9582 13.3582 22.6 13.8 22.6H22.6V13.8C22.6 13.3582 22.9582 13 23.4 13H25C25.4418 13 25.8 13.3582 25.8 13.8V22.6H34.6C35.0418 22.6 35.4 22.9582 35.4 23.4Z" fill="#191C28" />
                        </svg> 
                     }
                </div>
              
            </div>
        )
    }
}